import React, { useEffect, useCallback, useState } from "react";
import axios from "axios";
import Nav from "./Nav";
import ReactMarkdown from 'react-markdown'
import PuffLoader from 'react-spinners/PuffLoader';
import Modal from "react-modal";
import { css } from "@emotion/react";

const override = css`
    display: block;
    margin: auto;
    margin-top: 50px;
    border-color: red;
`;

const Notice = () => {
  const [limit, setLimit] = useState(10);
  const [notice, setNotice] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [noticeData, setNoticeData] = useState({
    title: "",
    content: "",
    date: "",
  });


  const getNoticeList = useCallback(async () => {  
    setLoading(true);
    axios
      .post("api/getNoticeList", {
        limit: limit,
      })
      .then((res) => {
        console.log(res.data);
        setNotice(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response) {
          console.log(err.response);
        }
      });
  }, [setLoading, setNotice, limit]);
  
  useEffect(() => {
    getNoticeList();
  }, [getNoticeList]);

  function convertHistoryDate(date) {
    const newDate = new Date(date);
    const createYear = newDate.getFullYear();
    const createMonth =
      newDate.getMonth() < 9
        ? "0" + (newDate.getMonth() + 1)
        : newDate.getMonth() + 1;
    const createDay =
      newDate.getDate() < 9 ? "0" + newDate.getDate() : newDate.getDate();
    const Data = createYear + "." + createMonth + "." + createDay;
    return Data;
  }

  function noticeOpen(index) {
    setNoticeData({
      title: notice[index].title,
      content: notice[index].content,
      date: notice[index].created_at,
    });
    setModalOpen(true);
  }

  function Loading(){              
    return(<PuffLoader color="#fff" loading={true} css={override} size={100} />)
  }  

  const noticeList = notice.map((row, idx) => (
    <tr  key={idx} onClick={() => noticeOpen(idx)}>
      <td width={'20%'} className="date">{convertHistoryDate(row.created_at)} </td>
      <td width={'80%'} className="title text-left">{row.title} </td>
    </tr>
  ));

  return (
    <div className="sub-container">
      <div className="content">
        <p className="hisTitle" style={{ marginLeft: 15 }}>
          Notice
        </p>
        {/* <p className="text-white description">제목을 누르면 공지사항을 확인할 수 있습니다.</p> */}
        <div className="receive-history history-wrap">
          <table className="history-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Title</th>
              </tr>
            </thead>            
            <tbody>
              {notice.length > 0 ? (
                noticeList
              ) : (
                <td className="no-data" colSpan="2">
                  No data.
                </td>
              )}
            </tbody>
          </table>
          {
            loading ? <Loading></Loading> 
            : 
            noticeList.length < limit? <div className="view-info">{noticeList.length===0?'No data':'End of list'}</div>                                        
            :<button className="btn view-more" onClick={() => setLimit(limit + 10)}>More ...</button>
          }                  
        </div>
      </div>
      <Modal
        closeTimeoutMS={200}
        isOpen={isModalOpen}
        onRequestClose={() => setModalOpen(false)}
      >
        <div className="notice-header">
          <p className="date">{convertHistoryDate(noticeData.date)}</p>
          <p className="title">{noticeData.title}</p>
        </div>
        <div className="notice-body">
          <ReactMarkdown>
            {noticeData.content}            
          </ReactMarkdown>    
        </div>
      </Modal>
      <Nav />
    </div>
  );
};

export default Notice;
